import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z"
}), 'CheckTwoTone');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/CheckTwoTone.js
// module id = 2777
// module chunks = 2